import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ListItem } from './list-item'

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListItemComponent {

  @Input() item: ListItem
  @Input() mdIcon: string

}



// WEBPACK FOOTER //
// ./src/app/shared/list-item/list-item.component.ts